import React from 'react';
import { Box, CircularProgress, CircularProgressProps } from '@mui/material';

interface Props extends CircularProgressProps {
  margin?: number;
  padding?: number;
}

const CustomSpinner = ({ margin = 0, padding = 12, ...rest }: Props) => {
  return (
    <Box
      p={padding}
      m={margin}
      width={'100%'}
      display={'flex'}
      justifyContent={'center'}
    >
      <CircularProgress color="secondary" {...rest} />
    </Box>
  );
};

export default CustomSpinner;
